<template>
  <div class="padded">
    <template v-if="error">
      {{error}}
    </template>
    <template v-else>
      Loading...
    </template>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  name: 'Success',
  data: () => ({
    error: null,
  }),
  mounted() {
    this.error = null
    const user = firebase.auth().currentUser
    const paymentAddedAt = Date.now()
    firebase.database().ref('users/' + user.uid).update({
      paymentAddedAt,
      checkoutSuccessId: this.$route.query.session_id
    }, err => {
      if (err) {
        this.error = err.message
      } else {
        this.$router.replace('/')
      }
    })
  },
}
</script>
<style scoped>
.padded {
  padding: 5rem 0;
  text-align: center;
}
</style>
